// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__nLeS8","backdrop":"Modal_backdrop__GzFvD","body":"Modal_body__jkW1S","closeButton":"Modal_closeButton__wSR7R"};